import { render, staticRenderFns } from "./xiaoai.vue?vue&type=template&id=01626124&scoped=true&"
var script = {}
import style0 from "./xiaoai.vue?vue&type=style&index=0&id=01626124&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01626124",
  null
  
)

export default component.exports